import React from 'react'
import GridItem from "components/Grid/GridItem.js";
import { makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    border: '1px solid rgb(15, 25, 150)',
    borderRadius: '3px',
    borderTop: 'none',
    overflow: 'hidden',
    display: 'flex',
    flexFlow: 'column nowrap',
    paddingLeft: '20px',
    marginTop: 10,

  },
  title: {
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '8px',
    marginLeft: '-20px',
    borderTop: '1px solid rgb(15, 25, 150)',
    borderBottom: '1px solid rgb(15, 25, 150)',
  }
}))

function CheckBoxGroup(props){
  const classes = useStyles()

  return(
    <GridItem direction={props.direction} xs={6} sm={6} md={4} lg={3} xl={2}>
      <div className={classes.root}>
        <Typography className={classes.title}>{props.title}</Typography>
        {props.children}
     </div>
    </GridItem>
  )
}
export default CheckBoxGroup
